<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'">
  </mat-progress-bar>
}
<!-- master-data -->
<div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">

  <!-- Header -->
  <div class="z-10 relative flex flex-row flex-0 w-full bg-gray-100 dark:bg-transparent">

    <!-- Title -->
    <div class="px-6 py-4 text-3xl font-semibold tracking-tight">
      {{ taskType?.name ? taskType.name : ('newTaskType' | transloco) }}
    </div>

    <!-- Action buttons -->
    <div class="flex flex-row flex-auto items-center justify-end">
      <!-- Delete -->
      @if (!isNew) {
        <button mat-raised-button class="mr-4" color="warn" (click)="deleteTaskType()">{{ 'delete' | transloco }}</button>
      }

      <!-- Cancel -->
      <button mat-raised-button class="mr-4" color="warn" (click)="cancel()">{{ 'cancel' | transloco }}</button>

      <!-- Save -->
      <button mat-raised-button class="mr-4" color="primary" (click)="save()">{{ 'save' | transloco }}</button>
    </div>
  </div>

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent">


    <!-- Tabs -->
    <!-- <mat-tab-group class="sm:px-2" *ngIf="taskType && dtypeForm" animationDuration="0"> -->

    <!-- Datatype general data -->
    <!-- <mat-tab label="{{ 'general' | transloco }}">
    <dtype-details [dtypeForm]="dtypeForm" [isUpdate]="!isNew"></dtype-details>
  </mat-tab> -->

  <!-- List preview -->
  <!-- <mat-tab label="{{ 'form' | transloco }}">
  <ng-template matTabContent>
    <task-type-form [forms]="taskType.forms" [locator]="locator"></task-type-form>
  </ng-template>
</mat-tab>
</mat-tab-group> -->

@if (dtypeForm && taskType) {
  @if (taskType.typology !== 'TASK_ASSIGNMENT') {
    <mat-tab-group class="sm:px-2" animationDuration="0">
      <!-- Datatype general data -->
      <mat-tab label="{{ 'general' | transloco }}">
        <dtype-details [dtypeForm]="dtypeForm" [isUpdate]="!isNew"></dtype-details>
      </mat-tab>
      <!-- Forms -->
      <mat-tab label="{{ 'form' | transloco }}">
        <ng-template matTabContent>
          <div class="prose prose-sm max-w-full mt-8 px-2">
            <h2>{{ 'form' | transloco }}</h2>
          </div>
          <task-type-form [forms]="taskType.forms" [locator]="locator" [taskType]="taskType"></task-type-form>
        </ng-template>
      </mat-tab>
      @if (taskType.typology !== 'WORKSHIFT') {
        <!-- Goals -->
        <mat-tab label="{{ 'goal.goals' | transloco }}">
          <ng-template matTabContent>
            <div class="prose prose-sm max-w-full mt-8 px-2">
              <h2>{{ 'goal.goals' | transloco }}</h2>
            </div>
            <task-type-goal [goals]="taskType.goals" [locator]="locator"></task-type-goal>
          </ng-template>
        </mat-tab>
        <!-- Form fields -->
        <mat-tab label="{{ 'fields' | transloco }}">
          <ng-template matTabContent>
            <dtype-fieldlist [dtype]="taskType.dtype" [locator]="locator" (changed)="changedDType($event)"></dtype-fieldlist>
          </ng-template>
        </mat-tab>
        <!-- Editor preview -->
        <mat-tab label="{{ 'editorPreview' | transloco }}">
          <ng-template matTabContent>
            <dtype-editor-preview [dtype]="taskType.dtype"></dtype-editor-preview>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  } @else {
    <dtype-details [dtypeForm]="dtypeForm" [isUpdate]="!isNew"></dtype-details>
  }
}
</div>
</div>

